var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartBar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00224 1.99872C3.55577 1.99872 4.00449 2.44643 4.00449 2.99872V20.0013H20.9978C21.5513 20.0013 22 20.449 22 21.0013C22 21.5536 21.5513 22.0013 20.9978 22.0013H3.15258C2.51603 22.0013 2 21.4864 2 20.8513V2.99872C2 2.44643 2.44872 1.99872 3.00224 1.99872Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68403 8.26916C7.23632 8.26916 7.68403 8.71688 7.68403 9.26916L7.68403 17.1187C7.68403 17.671 7.23632 18.1187 6.68403 18.1187C6.13175 18.1187 5.68403 17.671 5.68403 17.1187L5.68403 9.26916C5.68403 8.71688 6.13175 8.26916 6.68403 8.26916Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8598 14.0887C11.8598 13.5364 11.4121 13.0887 10.8598 13.0887C10.3075 13.0887 9.85981 13.5364 9.85981 14.0887V17.1187C9.85981 17.671 10.3075 18.1187 10.8598 18.1187C11.4121 18.1187 11.8598 17.671 11.8598 17.1187V14.0887Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0356 3.99872C15.5879 3.99872 16.0356 4.44643 16.0356 4.99872V17.1187C16.0356 17.671 15.5879 18.1187 15.0356 18.1187C14.4833 18.1187 14.0356 17.671 14.0356 17.1187V4.99872C14.0356 4.44643 14.4833 3.99872 15.0356 3.99872Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2114 11.0587C20.2114 10.5064 19.7637 10.0587 19.2114 10.0587C18.6591 10.0587 18.2114 10.5064 18.2114 11.0587V17.1187C18.2114 17.671 18.6591 18.1187 19.2114 18.1187C19.7637 18.1187 20.2114 17.671 20.2114 17.1187V11.0587Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar);
export default __webpack_public_path__ + "static/media/chart_bar.07e105f701b93bc55e1f55ddf8ccf2c7.svg";
export { ForwardRef as ReactComponent };